// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_l1-0";
export var discountCodeInput = "_l1-1";